var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "External Link") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "External-Link",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#EF6E4A",
    fillRule: "nonzero",
    transform: "translate(7.000000, 9.000000) scale(-1, -1) translate(-7.000000, -9.000000) ",
    points: "12.25 3.75 1.75 3.75 1.75 9 0 9 8.95283847e-13 2 14 2 14 16 7 16 7 14.25 12.25 14.25"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icn/chevron/black",
    transform: "translate(14.000000, 1.500000) rotate(-45.000000) translate(-14.000000, -1.500000) translate(12.000000, -2.000000)",
    fill: "#EF6E4A"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    transform: "translate(2.000000, 3.500000) scale(-1, 1) translate(-2.000000, -3.500000) ",
    points: "4 0.816666667 3.24324324 -3.82599935e-15 0 3.5 3.24324324 7 4 6.18333333 1.51351351 3.5"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#EF6E4A",
    transform: "translate(11.500000, 4.000000) rotate(-45.000000) translate(-11.500000, -4.000000) ",
    x: 7,
    y: 3,
    width: 9,
    height: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.c4e86467fff2de862a63469a8b79dfaf.svg";
export { ForwardRef as ReactComponent };